import React from "react"
import { IntlProvider } from "react-intl"

import messages_en from "../../assets/data/locales/en.json"
//import messages_de from "../../assets/data/locales/de.json"
//import messages_fr from "../../assets/data/locales/fr.json"
import messages_br from "../../assets/data/locales/pt.json"
//import messages_es from "../../assets/data/locales/es.json"

const menu_messages = {
  br: messages_br,
  en: messages_en
  //de: messages_de,
  //fr: messages_fr,
  //es: messages_es,
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: "br",
    messages: menu_messages["br"]
  }

  render() {
    const { children } = this.props
    const { locale, messages } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })
          }
        }}
      >
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="br"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
